const successFallback = () => ({});
const errorFallback = (error) => ({ error });
const abortedFallback = () => ({});
function createActionCreator(type, payloadCreator) {
    return (...args) => {
        const payload = payloadCreator ? payloadCreator(...args) : args[0];
        return payload !== undefined ? { type, payload } : { type };
    };
}
export const createAction = (type, actionPayloadCreator) => {
    return createAllActions(type, actionPayloadCreator, successFallback, errorFallback, abortedFallback);
};
export const createAllActions = (type, actionPayloadCreator, successActionPayloadCreator, failedActionPayloadCreator, abortedActionPayloadCreator) => {
    return {
        action: {
            type,
            action: createActionCreator(type, actionPayloadCreator),
        },
        success: {
            type: `${type}_SUCCESS`,
            action: createActionCreator(`${type}_SUCCESS`, successActionPayloadCreator),
        },
        failed: {
            type: `${type}_FAILED`,
            action: createActionCreator(`${type}_FAILED`, failedActionPayloadCreator),
        },
        aborted: {
            type: `${type}_ABORTED`,
            action: createActionCreator(`${type}_ABORTED`, abortedActionPayloadCreator),
        },
    };
};
